// Check if a value is negative
export default function (value, options) {
  if (value !== undefined && value < 0) {
    return options.fn(this);
  }
  return options.inverse(this);
}
